import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { defaultProducts, normalizeProduct } from '../data/products';

export function useProducts() {
  const [products, setProducts] = useState(defaultProducts);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'products'),
      (snapshot) => {
        if (snapshot.empty) {
          setProducts(defaultProducts);
        } else {
          const next = snapshot.docs.map((doc) => {
            const data = doc.data();
            return normalizeProduct({
              ...data,
              id: data.id || doc.id,
            });
          });
          setProducts(next);
        }
        setLoading(false);
        setError('');
      },
      () => {
        setProducts(defaultProducts);
        setLoading(false);
        setError('Nem sikerült betölteni a termékeket.');
      },
    );

    return () => unsub();
  }, []);

  return { products, loading, error };
}
